import { render, staticRenderFns } from "./DropDownComment.vue?vue&type=template&id=6d0c9240&scoped=true"
import script from "./DropDownComment.vue?vue&type=script&lang=js"
export * from "./DropDownComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c9240",
  null
  
)

export default component.exports